<script setup>
import BreezeButton from '@/Components/Button.vue';
import BreezeCheckbox from '@/Components/Checkbox.vue';
import BreezeGuestLayout from '@/Layouts/Guest.vue';
import BreezeInput from '@/Components/Input.vue';
import BreezeLabel from '@/Components/Label.vue';
import BreezeValidationErrors from '@/Components/ValidationErrors.vue';
import { Head, Link, useForm } from '@inertiajs/inertia-vue3';

const form = useForm({
  name: '',
  email: '',
  password: '',
  password_confirmation: '',
  terms: false,
});

const submit = () => {
  form.post(route('register'), {
    onFinish: () => form.reset('password', 'password_confirmation'),
  });
};
</script>

<template>

  <Head title="新規登録" />

  <BreezeGuestLayout>
    <section class="main login">

      <h2 class="login_title c-heading-h2">新規登録</h2>

      <p>ロード・オブ・ザ・ウォールのご利用にはユーザー登録が必要になります。（無料）</p>

      <BreezeValidationErrors class="mb-4" />

      <form @submit.prevent="submit">
        <input type="hidden" name="_token" :value="$page.props._token" />

        <div class="c-input_row">
          <BreezeLabel for="name" value="ニックネーム（公開される名前になります）" />
          <BreezeInput id="name" type="text" class="mt-1 block w-full" v-model="form.name" required autofocus autocomplete="name" />
        </div>

        <div class="c-input_row">
          <BreezeLabel for="email" value="メールアドレス" />
          <BreezeInput id="email" type="email" class="mt-1 block w-full" v-model="form.email" required autocomplete="username" />
        </div>

        <div class="c-input_row">
          <BreezeLabel for="password" value="パスワード" />
          <BreezeInput id="password" type="password" class="mt-1 block w-full" v-model="form.password" required autocomplete="new-password" />
        </div>

        <div class="c-input_row">
          <BreezeLabel for="password_confirmation" value="パスワード（確認）" />
          <BreezeInput id="password_confirmation" type="password" class="mt-1 block w-full" v-model="form.password_confirmation" required autocomplete="new-password" />
        </div>

        <div class="c-input_row">
          <label class="c-input_check-terms">
            <BreezeCheckbox name="terms" v-model:checked="form.processing" />
            <Link :href="route('terms')" target="_blank">利用規約</Link>と<Link :href="route('privacy')" target="_blank">プライバシーポリシー</Link>に同意する
          </label>
        </div>

        <div class="c-input_row">
          <BreezeButton class="c-button" :class="{ 'disabled': !form.processing }" :disabled="!form.processing">
            新規登録する
          </BreezeButton>
          <Link :href="route('login')" class="c_text-link">
            アカウントをお持ちの方はこちら
          </Link>
        </div>

      </form>
    </section>
  </BreezeGuestLayout>
</template>
